import React from 'react'

const ViewOnlyBox = ({ item, label }) => {
  const selectedValues = item.map((attr) => attr.name).join(', ')

  if (!selectedValues.length) return null

  return (
    <div className="filters__item">
      <span>
        <b>{label}:</b> {selectedValues}
      </span>
    </div>
  )
}

export default ViewOnlyBox
